/*
	Exibe o Popper Global
*/
export default ({ commit }, options ) => 
	commit("showPopper", options)

